import { ProductVariation } from 'editor/src/store/variants/types';

export const CUSTOM_PAGES_COUNT = 'custom';

/**
 * Products whose `pagescount` attribute is `custom` accept any page count inside the
 * product's range instead of a short list of fixed counts, so they get a number input
 * rather than a dropdown of every allowed value.
 */
function isCustomPageCountProduct(productVariations: ProductVariation[], productUid: string): boolean {
  const variation = productVariations.find((productVariation) => productVariation.productUid === productUid);
  return variation?.pagescount === CUSTOM_PAGES_COUNT;
}

export default isCustomPageCountProduct;
